const CORNER_PX = 100
const MAX_TAP_GAP_MS = 500
const TAPS_TO_OPEN = { partner: 10, full: 20 }

function cornerOf({ clientX, clientY }: PointerEvent): keyof typeof TAPS_TO_OPEN | undefined {
    if (clientY > CORNER_PX) {
        return undefined
    }
    if (clientX <= CORNER_PX) {
        return 'partner'
    }
    return clientX >= window.innerWidth - CORNER_PX ? 'full' : undefined
}

// A run of quick taps in a top corner: no DOM of our own, so it works on a partner's page where the game is the UI
export function watchCornerTaps(open: (full: boolean) => void) {
    let corner: keyof typeof TAPS_TO_OPEN | undefined
    let taps = 0
    let lastTapAt = 0
    document.addEventListener(
        'pointerdown',
        (event) => {
            const current = cornerOf(event)
            const continues = current && current === corner && event.timeStamp - lastTapAt <= MAX_TAP_GAP_MS
            taps = continues ? taps + 1 : 1
            corner = current
            lastTapAt = event.timeStamp
            if (current && taps === TAPS_TO_OPEN[current]) {
                open(current === 'full')
            }
        },
        { capture: true, passive: true },
    )
}
